import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { UtilityService } from '../../../core/services/utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList, DatabaseReference } from 'angularfire2/database';
import { Constants } from '../../../core/config/Constants';
import { NewPageList } from '../../../core/models/new-page-list';
import { firebase } from '@firebase/app';
import { ContentsMandatory } from '../../../core/models/contents-mandatory';
@Injectable()
export class NewPageService {

  constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

  private static validate = new BehaviorSubject<boolean>(null);

  validate$: Observable<boolean> = NewPageService.validate.asObservable();

  private static upItem = new BehaviorSubject<NewPageList>(null);

  up$: Observable<NewPageList> = NewPageService.upItem.asObservable();

  private static downItem = new BehaviorSubject<NewPageList>(null);

  down$: Observable<NewPageList> = NewPageService.downItem.asObservable();

  private static removeItem = new BehaviorSubject<NewPageList>(null);

  remove$: Observable<NewPageList> = NewPageService.removeItem.asObservable();

  setNewPageList(eventId: string, newPageList: Array<NewPageList>, pageSlug: string): Promise<any> {
    return this.db.object(Constants.EVENT_URL + '/' + eventId + '/' + pageSlug).set(newPageList);
  }

  getNewPageList(eventId: string, pageSlug: string): Observable<NewPageList[]> {
    let data: AngularFireObject<NewPageList[]> = this.db.object(Constants.EVENT_URL + '/' + eventId + '/' + pageSlug);
    return data.valueChanges();
  }

  upItem(newPageList: NewPageList) {
    NewPageService.upItem.next(newPageList);
  }

  downItem(newPageList: NewPageList) {
    NewPageService.downItem.next(newPageList);
  }

  removeItem(newPageList: NewPageList) {
    NewPageService.removeItem.next(newPageList);
    console.log(newPageList);
  }

  addValidation(isValidate: boolean) {
    NewPageService.validate.next(isValidate);
  }

  uploadFile(eventId: string, file: File, cmCategory: string): any {

    if (cmCategory) {
      console.log(cmCategory, 'inside service')
      let storageRef = firebase.storage().ref();
      let path = eventId + Constants.Contents_Mandatory_URL + '/' + cmCategory;
      console.log(path);
      return storageRef.child(`${path}/${file.name}`).put(file);

    } else {
      let storageRef = firebase.storage().ref();
      let path = eventId + Constants.Contents_Mandatory_URL + '/' + Constants.EVENT_ABOUT_URL;
      console.log(path);
      return storageRef.child(`${path}/${file.name}`).put(file);
    }

  }

  getFile(contentsMandatory: ContentsMandatory, eventId: string): Promise<any> {
    return firebase.storage().ref().child
      ("/" + eventId + Constants.Contents_Mandatory_URL + "/" + contentsMandatory.category + "/" + contentsMandatory.filename).getDownloadURL();
  }

  addContentMandatory(contentsMandatory: ContentsMandatory): string {
    return this.db.list(Constants.EVENT_URL + '/' + contentsMandatory.eventId + Constants.Contents_Mandatory_URL)
      .push(contentsMandatory).key;
  }

  getContentsMandatory(id: string, eventId: string): Observable<ContentsMandatory> {
    let data: AngularFireObject<ContentsMandatory> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.Contents_Mandatory_URL + '/' + id);
    return data.valueChanges()
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/templates/new-page/service/new-page.service.ts